module.exports = __webpack_public_path__ + "img/inventory_2.84d13ced.svg";